<ion-searchbar
  data-testid="suburb-selector-modal-searchbar"
  [value]="suburb"
  readonly
  (click)="showSuburbModel()"
  [class.asInput]="asInput"
  [class.required]="isRequired"
  search-icon="search"
  (ionInput)="showSuburbModel($event)"
></ion-searchbar>
